import { cn } from "../../../lib/utils";

export default function Divider({className}) {
    return (
        <div className={cn(`divider border-b border-success-100 `, className)}></div>
    )
}
